<div data-cy="insurance-payerids-container">

  <div class="section-header" data-cy="insurance-payerids-header">
    <div class="section-header-title" data-cy="insurance-payerids-title">Select Payer ID (NEIC)</div>
  </div>




  <div style="margin: 10px;" *ngIf="!isLoading" data-cy="insurance-payerids-content">

     <dx-data-grid
       [dataSource]="cfgInsurancePayers"
       keyExpr="PayerID"
       height="540"
       [selectedRowKeys]="zselectedRowKeys"
       [focusedRowKey]="zselectedRowKeys[0]"
       [focusedRowEnabled]="true"
       [autoNavigateToFocusedRow]= "true"
        (onSelectionChanged)="onSelectionOfPayer($event)"
        data-cy="insurance-payerids-grid"
     >
       <dxo-selection mode="single" data-cy="insurance-payerids-selection"></dxo-selection>
       <dxo-paging [enabled]="false" data-cy="insurance-payerids-paging"></dxo-paging>
       <dxo-search-panel [visible]="true" placeholder="Search..." data-cy="insurance-payerids-search"></dxo-search-panel>


       <dxi-column dataField="Oragnization" caption="Payer Name" [width]="400" data-cy="insurance-payerids-org-column"></dxi-column>
       <dxi-column dataField="PayerIDperNEIC" caption="Payer ID" [width]="100" [setCellValue]="onSetPayerValue" data-cy="insurance-payerids-id-column"></dxi-column>




<!--       <dxo-toolbar>-->
<!--         <dxi-item  >-->
<!--           <dx-button-->
<!--             (onClick)="addRecord()"-->
<!--             icon="add"-->
<!--             text="Add New Payer"-->
<!--           />-->
<!--         </dxi-item>-->
<!--         <dxi-item location="after">-->
<!--           <dx-button-->
<!--             icon="trash"-->
<!--             text="Delete Selected Record"-->
<!--             (onClick)="deleteRecord()"-->
<!--           >-->
<!--           </dx-button>-->
<!--         </dxi-item>-->
<!--       </dxo-toolbar>-->



     </dx-data-grid>

    <div *ngIf="isEditMode" style="width: 450px; height: 200px; top: 200px; left: 40px;  position: absolute; z-index: 9; border-width: 3px;border-color: #00a8ff; border-style: solid; padding: 5px; background-color: white;" data-cy="insurance-payerids-edit-modal">

      <b data-cy="insurance-payerids-edit-title">Edit Payer</b>
      <table data-cy="insurance-payerids-edit-form">
        <tr data-cy="insurance-payerids-name-row">
          <td data-cy="insurance-payerids-name-label">
            Payer Name:
          </td>
          <td data-cy="insurance-payerids-name-field">
            <dx-text-box [width]="300" [(value)]="payerSelected.Oragnization" data-cy="insurance-payerids-name-input"/>
          </td>

        </tr>
        <tr data-cy="insurance-payerids-id-row">
          <td data-cy="insurance-payerids-id-label">
            Payer ID:
          </td>
          <td data-cy="insurance-payerids-id-field">
            <dx-text-box [(value)]="payerSelected.PayerIDperNEIC" data-cy="insurance-payerids-id-input"/>
          </td>

        </tr>
        <tr data-cy="insurance-payerids-delete-row">
          <td data-cy="insurance-payerids-delete-label">
            Delete:
          </td>
          <td data-cy="insurance-payerids-delete-field">
            <dx-check-box [(value)]="payerSelected.xauditDeleted" data-cy="insurance-payerids-delete-checkbox"/>
          </td>

        </tr>
        <tr data-cy="insurance-payerids-buttons-row">
          <td data-cy="insurance-payerids-buttons-empty">

          </td>
          <td data-cy="insurance-payerids-buttons-container">
           <dx-button text="Save" [width]="100"
                      (onClick)="onPayerEditSave()"
                      data-cy="insurance-payerids-save-button"
           >
           </dx-button>
            <dx-button text="Cancel" [width]="100"
                       (onClick)="onPayerEditCancel()"
                       data-cy="insurance-payerids-cancel-edit-button"
            >
            </dx-button>
          </td>

        </tr>

      </table>




    </div>


<!--    <div style="height: 535px;">-->
<!--      <tdo-table [dataSource]="cfgInsurancePayers"-->
<!--                 [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"-->
<!--                 [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)">-->
<!--        <tdo-table-column displayName="Payer ID" propertyName="PayerIDperNEIC" isSortable="true" [rowTemplate]="code">-->
<!--          <ng-template #code let-row>-->
<!--            <div *ngIf="row.PayerIDperNEIC">{{ row.PayerIDperNEIC }}</div>-->
<!--          </ng-template>-->
<!--        </tdo-table-column>-->
<!--        <tdo-table-column displayName="Payer Name" propertyName="Oragnization" isSortable="true" [rowTemplate]="organization">-->
<!--          <ng-template #organization let-row>-->
<!--            <div *ngIf="row.Oragnization">{{ row.Oragnization }}</div>-->
<!--          </ng-template>-->
<!--        </tdo-table-column>-->
<!--      </tdo-table>-->
<!--    </div>-->



    <table style="width: 100%" data-cy="insurance-payerids-actions-table">
      <tr data-cy="insurance-payerids-actions-row">
        <td data-cy="insurance-payerids-left-actions">
      <div style="text-align: left;" data-cy="insurance-payerids-add-edit-container">
        <dx-button
          text="Add"
          (onClick)="addRecord()"
          data-cy="insurance-payerids-add-button"
        >


        </dx-button>
        <dx-button
          text="Edit"
          (onClick)="editRecord()"
          data-cy="insurance-payerids-edit-button"
        >
        </dx-button>
      </div>
        </td>
<td data-cy="insurance-payerids-right-actions">
      <div style="text-align: right;" data-cy="insurance-payerids-select-cancel-container">

          <dx-button
            text="Select"
            (onClick)="selectPayer()"
            data-cy="insurance-payerids-select-button"
          >


          </dx-button>
          <dx-button
            text="Cancel"
            (onClick)="cancel()"
            data-cy="insurance-payerids-cancel-button"
          >
          </dx-button>
      </div>
</td>
      </tr>
    </table>

  </div>
</div>

<app-tdo-progress-spinner *ngIf="isLoading" data-cy="insurance-payerids-loading"></app-tdo-progress-spinner>





